import { Facebook, Twitter, Instagram, Mail } from 'lucide-react';

interface FooterProps {
  onNavigate?: (page: string) => void;
}

export default function Footer({ onNavigate }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">PassportPhoto</h3>
            <p className="text-sm text-gray-400">
              Generate professional passport photos that meet official requirements for any country.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => onNavigate?.('home')} className="text-sm hover:text-white transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate?.('about')} className="text-sm hover:text-white transition-colors">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate?.('help')} className="text-sm hover:text-white transition-colors">
                  Help
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate?.('contact')} className="text-sm hover:text-white transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => onNavigate?.('photo-guidelines')} className="text-sm hover:text-white transition-colors">
                  Photo Guidelines
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate?.('country-requirements')} className="text-sm hover:text-white transition-colors">
                  Country Requirements
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate?.('privacy-policy')} className="text-sm hover:text-white transition-colors">
                  Privacy Policy
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate?.('terms-of-service')} className="text-sm hover:text-white transition-colors">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Connect With Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-white transition-colors" aria-label="Follow us on Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="Follow us on Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="Follow us on Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="Contact us via email">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© 2025 PassportPhoto. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
